import React from "react";
import loaderStyle from "../style/loader.module.css";

const ContentLoader = () => {
  return (
    <div className={loaderStyle.contentLoaderContainer}>
      <div className={loaderStyle.contentLoader} />
    </div>
  );
};
export default ContentLoader;
